//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: "LogLoginList",
  mixins: [JeecgListMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/sys/log/login',
      pageTitle: '登录日志',
      isorter: {
        column: 'login_time',
        order: 'desc'
      },
      // 表头
      columns: [// {
      //     title: '序号',
      //     dataIndex: '',
      //     key: 'rowIndex',
      //     width: 60,
      //     align: "center",
      //     customRender: function (t, r, index) {
      //         return parseInt(index) + 1;
      //     }
      // },
      {
        dataIndex: 'userName',
        colName: 'user_name',
        title: '用户名称',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'realName',
        colName: 'real_name',
        title: '真实姓名',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'clientIp',
        colName: 'client_ip',
        title: '客户端IP',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'serverIp',
        colName: 'server_ip',
        title: '服务端IP',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'loginTime',
        colName: 'login_time',
        title: '登录时间',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'logoutTime',
        colName: 'logout_time',
        title: '退出时间',
        align: "center",
        sorter: true
      } // {
      //     dataIndex: 'accessChannelId',
      //     colName: 'access_channel_id',
      //     title: '访问渠道',
      //     align: "center",
      //     sorter: true
      // },
      // {
      //     dataIndex: 'accessPlatform',
      //     colName: 'access_platform',
      //     title: '访问平台',
      //     align: "center",
      //     sorter: true
      // },
      ]
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    onLoginMonitorDate: function onLoginMonitorDate(value, dateArray) {
      this.queryParam.loginTimeStart = dateArray[0];
      this.queryParam.loginTimeEnd = dateArray[1];
    },
    onLogoutMonitorDate: function onLogoutMonitorDate(value, dateArray) {
      this.queryParam.logoutTimeStart = dateArray[0];
      this.queryParam.logoutTimeEnd = dateArray[1];
    }
  }
};